import React, { Component } from "react"
import PropTypes from "prop-types"

class GroupedSelectList extends Component {
  state = { value: this.props.initialSelection ? this.props.initialSelection.id : "" }

  onSelectChange = (e) => {
    this.setState({ value: e.target.value })
    this.props.onSelectChange(e)
  }

  setInitialOption = () => {
    return (
      <option
        disabled={this.props.initialSelection.disabled}
        key={this.props.initialSelection.id}
        value={this.props.initialSelection.id}
      >
        {this.props.initialSelection.text}
      </option>
    )
  }

  generateOptions = () => {
    const groupedOptions = this.props.data

    if (groupedOptions && groupedOptions.length > 0) {
      return groupedOptions.map((gq) => {
        return (
          <optgroup label={gq.groupNameTranslatedText}>
            {
              gq.questions.map((q) => {                
                return (
                  <option key={q.uniqueReference} value={q.uniqueReference}>
                    {q.questionTextTranslatedText}
                  </option>
                )
              })
            }
          </optgroup>
        )
      })
    }

    return <option />
  }

  render() {
    return (
      <select className="form-control" onChange={this.onSelectChange} value={this.state.value}>
        {this.props.initialSelection ? this.setInitialOption() : null}
        {this.generateOptions()}
      </select>
    )
  }
}

GroupedSelectList.propTypes = {
  initialSelection: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  }),
  onSelectChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    count: PropTypes.number,
  })).isRequired,
}

GroupedSelectList.defaultProps = {
  initialSelection: null,
}

export default GroupedSelectList



// WEBPACK FOOTER //
// ./src/components/inputs/GroupedSelectList.jsx